var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#43AC43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C6.44772 6 6 6.44772 6 7V19C6 19.5523 6.44772 20 7 20H19C19.5523 20 20 19.5523 20 19V7C20 6.44772 19.5523 6 19 6H14.5C13.9477 6 13.5 6.44772 13.5 7V14.2929L16.1464 11.6464C16.3417 11.4512 16.6583 11.4512 16.8536 11.6464C17.0488 11.8417 17.0488 12.1583 16.8536 12.3536L13.3536 15.8536C13.1583 16.0488 12.8417 16.0488 12.6464 15.8536L9.14645 12.3536C8.95118 12.1583 8.95118 11.8417 9.14645 11.6464C9.34171 11.4512 9.65829 11.4512 9.85355 11.6464L12.5 14.2929V7C12.5 5.89543 13.3954 5 14.5 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H7C5.89543 21 5 20.1046 5 19V7C5 5.89543 5.89543 5 7 5H9.5C9.77614 5 10 5.22386 10 5.5C10 5.77614 9.77614 6 9.5 6H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDownload);
export default __webpack_public_path__ + "static/media/green-download.d493474d064088e7b14a64fb3cbd1a5b.svg";
export { ForwardRef as ReactComponent };